<template>
  <div id="register">
    <h3 class="greetingHeader">Welcome To PreEvent</h3>

    <b-container>
      <b-form @submit.prevent="handleResend" id="registerForm">
        <!-- Row 1: Email Verification -->
        <b-row class="text-center">
          <h3>Email Verification</h3>
          <p>We have sent the activation link to the email provided</p>
          <p>If you haven't received an email, click 'Resend'</p>
        </b-row>

        <!-- Resend Button -->
        <b-row>
          <b-col>
            <b-form-group>
              <b-button
                class="w-100"
                type="submit"
                id="registerButton"
                :disabled="showLoading"
              >
                <template v-if="showLoading">
                  <img
                    src="../../assets/admin_loading.gif"
                    alt="Loading"
                    class="loader"
                  />
                </template>
                <template v-else> Resend </template>
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Display messages -->
        <b-row class="text-center">
          <b-col>
            <p v-if="message" class="text-success">{{ message }}</p>
            <p v-if="error" class="text-danger">{{ error }}</p>
          </b-col>
        </b-row>
      </b-form>

      <!-- Back Link -->
      <b-container class="text-center">
        <router-link to="/login" id="loginLink">Back</router-link>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";

export default {
  data() {
    return {
      message: "",
      error: "",
      showLoading: false,
    };
  },
  methods: {
    async handleResend() {
      this.showLoading = true;
      try {
        // Assuming the email is stored in local storage or a cookie
        const email = localStorage.getItem("userEmail"); // or replace with cookie retrieval logic

        if (!email) {
          throw new Error("Email address is not available.");
        }

        const response = await axios.post(
          `${API_BASE_URL}/resend-verification-email`,
          {
            admin_users_email: email,
          }
        );

        this.message = response.data.message;
        this.error = "";
      } catch (error) {
        if (error.response && error.response.data) {
          this.error = error.response.data.message || "An error occurred";
          this.showLoading = false;
        } else {
          this.error = error.message || "An error occurred";
          this.showLoading = false;
        }
        this.message = "";
      } finally {
        this.showLoading = false;
      }
    },
  },
};
</script>

<style scoped>
#register {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #bfc7d6;
  padding: 40px 40px 120px 40px;
  border-radius: 5px;
  font-family: "Kumbh Sans", sans-serif;
  font-weight: 600;

}

h1 {
  font-weight: 600;
}
.greetingHeader {
  margin-bottom: 40px;
}
p {
  font-size: 12px;
  margin-bottom: 30px;
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}
h3 {
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}

#email,
#password {
  margin-bottom: 20px;
}

#registerButton {
  background-color: #23305b;
  margin: 20px auto 0px auto;
}

/* ---------------------for password eye icon----------------------------- */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-toggle i {
  font-size: 1.25rem;
  color: black;
}


@media (min-width: 600px) {
  #register {
    width: 550px;
  }
}

@media (max-width: 600px) {
  #register {
    border: none;
  }
}

#loginLink {
  color: #23305b;
  text-decoration: none;
}

.text-success,
.text-danger {
  margin: 0;
}
/* ------------------------loading gif--------------------------------- */
.loader {
  width: 20px; /* Adjust size as needed */
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
</style>
